import { Metric } from 'user/api/dashboardsWidgets';

/** ウィジェットの対象ストリームIDのセットを返します。 */
export function getStreamIdSet(metrics: Metric[]) {
  return new Set(metrics.map((m) => m.stream_id));
}
